// @ts-nocheck
import { Fragment, useEffect, useMemo } from 'react';

import NewArrowLeft from '@crehana/icons/NewArrowLeft';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { TextLink } from '@crehana/ui';
import Helmet from 'react-helmet';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Link, Route, Switch, useHistory, useLocation } from 'react-router-dom';

import { useTranslation } from '../hooks';
import routes from './config';

const RouteSwitch = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const currentRoute = useMemo(
    () => routes.find(r => location.pathname.includes(r.path)),
    [location.pathname],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  useEffect(() => {
    if (location.pathname === '/' && window.innerWidth >= 768) {
      history.push(routes[0].path);
    }
  }, [location.pathname]);

  const title =
    currentRoute?.title ??
    t([`${currentRoute ? currentRoute.key : routes[0].key}_TITLE`]);

  return (
    <div
      className="w-full flex flex-col justify-between overflow-auto"
      css={`
        ${({ theme }) => theme.breakpoints.up('sm')} {
          padding-top: 100px;
        }
      `}
    >
      <Helmet>
        <title>{`${title} | Crehana`}</title>
      </Helmet>
      {currentRoute && (
        <Fragment>
          <Link to="/">
            <TextLink
              as="div"
              className="mb-24 sm:hidden"
              leftIcon={{ component: NewArrowLeft }}
              label={t('GO_BACK')}
            />
          </Link>
          <h2 className="font-h3 mb-8">{title}</h2>
          {currentRoute.subtitle && (
            <p className="font-body3 mb-8">{currentRoute.subtitle}</p>
          )}
          <p className="font-label text-gray-dark">
            {t('UPDATED_AT')} {currentRoute.updatedAt}
          </p>
        </Fragment>
      )}
      <Switch>
        {routes.map(route => (
          <Route key={route.key} path={route.path} exact={route.exact}>
            <route.component />
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default RouteSwitch;
